import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'bi-notification-badge',
  templateUrl: './notification-badge.html',
  styleUrl: './notification-badge.scss',
})
export class NotificationBadge {
  /** When true, uses pending style (red circle, white number). When false, uses standard (black border, white bg, black number). */
  readonly pendingMode = input<boolean>(false);

  /** Number of items to show. Badge is hidden when 0 or less. */
  readonly count = input.required<number>();

  /** When count exceeds this value, show "max+" (e.g. "99+"). Ignored when not set. */
  readonly max = input<number | undefined>(undefined);

  /** Display value: count, or "max+" when over max, or null when hidden. */
  readonly displayValue = computed(() => {
    const c = this.count();
    if (c <= 0) return null;
    const maxVal = this.max();
    if (maxVal !== undefined && c > maxVal) return `${maxVal}+`;
    return String(c);
  });

  readonly ariaLabel = computed(() => {
    const c = this.count();
    if (c <= 0) return null;
    return `${c} pending`;
  });
}
